import React from "react"
import {FieldViewProps} from "../../../../render/view";
import FieldToggle_Component from "../components/toggle-stateless";
import {ToggleSize} from "../components/toggle-statefull"

export default function FieldToggle_View(props: FieldViewProps) {

    const value = props.model[props.field.fieldId]

    return <FieldToggle_Component size={ToggleSize.SIZE_20} value={value} disabled={props.field.isDisabled}/>
    // return <FieldToggle_Component size='20' value={value} disabled={true}/>

}